import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PrincipalService } from './principal.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  endpoint: string = environment.zoomEndpoint;
  constructor(private http: HttpClient, private principal: PrincipalService) {
    this.setFeatureFlags();
    this.scheduleFeatureFlagLoading();
  }
  getFeatureFlags() {
    return this.http.get(`${this.endpoint}api/feature-flags`);
  }
  setFeatureFlags() {
    if (!localStorage.getItem('featureFlags')) {
      this.loadFeatureFlags();
      return;
    }
    const expirationTime = localStorage.getItem('featureFlagsExpirationTime');
    if (expirationTime) {
      const now = new Date();
      const expirationDate = new Date(expirationTime);
      if (now >= expirationDate) {
        this.loadFeatureFlags();
      }
    } else {
      this.loadFeatureFlags();
    }
  }
  loadFeatureFlags() {
    console.log('Refreshing feature flags');
    this.getFeatureFlags().subscribe({
      next: (res: any) => {
        localStorage.setItem('featureFlags', JSON.stringify(res.data));
        const expirationInterval = 180000 - 1; // 3 minutes
        const now = new Date();
        const expirationTime = new Date(now.getTime() + expirationInterval);
        localStorage.setItem(
          'featureFlagsExpirationTime',
          expirationTime.toISOString()
        );
        console.log('Next load time: ', expirationTime.toISOString());
      },
      error: (err) => {
        console.log('Error loading feature flags: ', err);
      },
    });
  }
  scheduleFeatureFlagLoading() {
    setInterval(() => {
      this.setFeatureFlags();
    }, 60000);
  }
  isEnabled(featureFlag: string) {
    if (!localStorage.getItem('featureFlags')) {
      return false;
    }
    const featureFlags: any[] = JSON.parse(
      localStorage.getItem('featureFlags') as any
    );
    if (!featureFlags || featureFlags.length === 0) {
      console.log('No feature flags found');
      return false;
    }
    const feature = featureFlags.find((f) => f.featureName === featureFlag);
    if (!feature) {
      return false;
    }
    if (feature.isPublished) {
      return true;
    }
    if (this.principal.hasFeature(featureFlag)) {
      return true;
    }
    return false;
  }
}
